//create, update
export class ShoppingMallRequest{
    name: string;
    
}

export class ShoppingMallRequestSearch{
    name: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    
}
